module.exports = __webpack_public_path__ + "img/case07.8f02e249.png";